// Mock data for Trustar Industrial Chemicals - Global Distribution

export const companyInfo = {
  name: 'Trustar Industrial Chemicals',
  legalName: 'Trustar Basic Industrial Chemicals Trading DWC-LLC',
  tagline: 'Precision in Pigment. Power in Performance.',
  heroTitle: 'Global Distribution of Titanium Dioxide and Specialty Pigments',
  heroDescription: 'Global distribution of premium Titanium Dioxide and specialty pigments powering coatings, plastics, inks, and industrial applications worldwide.',
  whatsappNumber: '+971552366747', // WhatsApp number for enquiries
  whatsappLink: 'https://wa.me/971552366747',
  address: {
    line1: 'DWC Business Center',
    line2: 'Level-3, Building-A3',
    line3: 'Dubai South Business Park',
    poBox: 'P.O. Box 390667',
    city: 'Dubai',
    country: 'U.A.E.'
  },
  contact: {
    email: 'sales@trustarchem.com',
    whatsapp: '+971 55 236 6747',
    phone: '+971 55 236 6747'
  },
  regions: ['Middle East', 'Africa', 'Latin America'],
  description: 'Trustar Industrial Chemicals is a leading global distributor of premium titanium dioxide and specialty pigments. We serve the Middle East, Africa, and Latin America with world-class products from renowned manufacturers including Tinergy, Titax, and Albalux.',
  mission: 'To deliver excellence in pigment distribution through strategic partnerships, technical expertise, and unwavering commitment to quality across global markets.',
  values: [
    'Trust',
    'Integrity',
    'Quality Excellence',
    'Global Reach',
    'Technical Expertise',
    'Customer Partnership'
  ],
  industriesServed: [
    { name: 'Paints & Coatings', icon: 'Paintbrush' },
    { name: 'Plastics', icon: 'Box' },
    { name: 'Inks', icon: 'FileText' },
    { name: 'Masterbatch', icon: 'Palette' },
    { name: 'PVC', icon: 'Layers' },
    { name: 'Specialty Applications', icon: 'Sparkles' }
  ]
};

// Homepage rotating banners - 4 total (2 visible initially)
export const heroBanners = [
  {
    id: 1,
    title: 'Global Distribution of Titanium Dioxide and Specialty Pigments',
    subtitle: 'Serving Middle East, Africa & Latin America with precision and reliability',
    gradient: 'from-blue-600 via-indigo-700 to-purple-800',
    pattern: 'premium-abstract', // Will have abstract pattern overlay
    cta: 'Explore Our Partners',
    ctaLink: '/',
    visible: true
  },
  {
    id: 2,
    title: 'Tinergy - Exclusive Middle East Partner',
    subtitle: 'Representing CNNC, CHTI & Anhui Gold Star - China\'s 2nd Largest TiO₂ Manufacturing Group',
    gradient: 'from-slate-800 via-gray-900 to-zinc-900',
    pattern: 'geometric-lines',
    cta: 'View Tinergy Products',
    ctaLink: '/products/tinergy',
    visible: true
  },
  {
    id: 3,
    title: 'Custom Formulations by Albalux',
    subtitle: 'Specialty pigments tailored to your exact specifications',
    gradient: 'from-purple-700 via-indigo-800 to-blue-900',
    pattern: 'fluid-gradient',
    cta: 'Discover Custom Solutions',
    ctaLink: '/products/albalux',
    visible: false // Hidden for now
  },
  {
    id: 4,
    title: 'Titax Premium TiO₂ Solutions',
    subtitle: 'Global distribution of high-performance titanium dioxide grades',
    gradient: 'from-cyan-700 via-blue-800 to-indigo-900',
    pattern: 'wave-pattern',
    cta: 'View Titax Range',
    ctaLink: '/products/titax',
    visible: false // Hidden for now
  }
];

// Brand information
export const brands = [
  {
    id: 'tinergy',
    name: 'Tinergy',
    fullName: 'Tinergy (CHTI, CNNC & Anhui Gold Star)',
    slug: 'tinergy',
    tagline: 'China\'s 2nd Largest TiO₂ Manufacturer',
    description: 'Tinergy represents CNNC, CHTI & Anhui Gold Star - China\'s 2nd largest titanium dioxide manufacturing group. These legacy brands are globally recognized for consistent quality, large-scale production, and technical excellence in TiO₂ manufacturing.',
    region: 'Exclusive for Middle East',
    manufacturer: 'CNNC, CHTI & Anhui Gold Star',
    gradient: 'from-blue-600 to-indigo-700',
    logoUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/22sijh1z_Tinergy%20logo%20vi%E9%92%9B%E8%83%BD%E5%8C%96%E5%AD%A6LOGO-%E4%B8%8A%E4%B8%8B%E5%BD%A2%E5%BC%8F%E4%BA%8C.png',
    products: [
      {
        id: 'tinergy-r213',
        name: 'R-213',
        grade: 'Rutile',
        category: 'Plastic Grade',
        description: 'High quality masterbatch grade with excellent dispersibility and food contact compliance.',
        applications: ['Masterbatch', 'Color Sheets', 'Food Contact'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_1c7e218a-d8c9-4628-9bce-2ff7630fe619/artifacts/1rvrxy7f_R-213%C2%A0TDS%C2%A0EN%C2%A02021.7.pdf',
        mockupUrl: null // Will be provided by user
      },
      {
        id: 'tinergy-r216',
        name: 'R-216',
        grade: 'Rutile',
        category: 'Coatings Grade',
        description: 'Outstanding hiding power and excellent weatherability for exterior applications.',
        applications: ['Exterior Coatings', 'Weather Resistant'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_1c7e218a-d8c9-4628-9bce-2ff7630fe619/artifacts/senplpim_R-216%C2%A0TDS%C2%A0EN%C2%A02022.5.pdf',
        mockupUrl: null
      },
      {
        id: 'tinergy-r219',
        name: 'R-219',
        grade: 'Rutile',
        category: 'Multi-Purpose Grade',
        description: 'High opacity and versatility for PVC profiles, powder coatings, and plastics.',
        applications: ['PVC Profiles', 'Powder Coatings', 'Road Paints'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_1c7e218a-d8c9-4628-9bce-2ff7630fe619/artifacts/3dtz9q3i_R-219%C2%A0TDS%C2%A0EN%C2%A02022.2.pdf',
        mockupUrl: null
      },
      {
        id: 'tinergy-r2196',
        name: 'R-2196',
        grade: 'Rutile',
        category: 'Paint Grade',
        description: 'High whiteness with blue undertone and exceptional gloss for premium paints.',
        applications: ['Furniture Paint', 'Industrial Paint'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_1c7e218a-d8c9-4628-9bce-2ff7630fe619/artifacts/1x0vai2y_R-2196%C2%A0TDS%C2%A0EN%C2%A02021.7.pdf',
        mockupUrl: null
      },
      {
        id: 'tinergy-r2196plus',
        name: 'R-2196+',
        grade: 'Rutile',
        category: 'Premium Grade',
        description: 'Versatile premium grade for multiple applications with superior performance.',
        applications: ['Latex Paint', 'Industrial Coatings', 'Inks'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_1c7e218a-d8c9-4628-9bce-2ff7630fe619/artifacts/jnurlzzb_R-2196%2B%C2%A0TDS%C2%A0EN%C2%A02021.7.pdf',
        mockupUrl: null
      }
    ]
  },
  {
    id: 'titax',
    name: 'Titax',
    fullName: 'Titax Titanium Dioxide',
    slug: 'titax',
    tagline: 'Premium Performance TiO₂',
    description: 'Global distribution of Titax premium titanium dioxide grades, delivering exceptional quality for paints, coatings, plastics, and industrial applications worldwide.',
    region: 'Global Distribution',
    manufacturer: 'Titax',
    gradient: 'from-gray-700 to-slate-800',
    logoUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/mnrnq4k7_TITAX%20LOGO%20%28R%29.png',
    products: [
      {
        id: 'titax-a315',
        name: 'A-315',
        grade: 'Anatase',
        category: 'Fiber Grade',
        description: 'High-grade fiber titanium dioxide with excellent dispersion in water and ethylene glycol. Features fine particle size, low iron content, and short grinding time.',
        applications: ['Synthetic Fiber', 'Chemical Fiber', 'Textile Applications'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/xuw79lcs_TITAX%20TDS%20A-315.pdf',
        mockupUrl: null
      },
      {
        id: 'titax-a900',
        name: 'A-900',
        grade: 'Anatase',
        category: 'High-Grade Pigment',
        description: 'High-purity anatase grade with excellent opacity, gloss, and electronic resistivity. Ideal for applications requiring high color brilliance and stability.',
        applications: ['Masterbatch', 'Printing Ink', 'Paper', 'Chemical Fiber'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/m7u6kjns_TITAX%20TDS%20A-900.pdf',
        mockupUrl: null
      },
      {
        id: 'titax-r414',
        name: 'R-414',
        grade: 'Rutile',
        category: 'General Purpose',
        description: 'Versatile rutile grade with high whiteness, gloss, scattering power, and durability. Surface treated with alumina, zirconia, and organic components.',
        applications: ['Coatings', 'Plastics', 'Ink', 'Paper'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/8plvhbxw_TITAX%20TDS%20R-414.pdf',
        mockupUrl: null
      },
      {
        id: 'titax-cr801',
        name: 'CR-801',
        grade: 'Chloride Rutile',
        category: 'Paint & Coating Grade',
        description: 'Premium chloride process rutile with excellent weather resistance. Perfect for exterior applications requiring superior durability and high gloss.',
        applications: ['Industrial Coatings', 'Architectural Coatings', 'Outdoor Water-Based Paint', 'Oil Paint'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/2km9uh0n_TITAX%20TDS%20CR-801.pdf',
        mockupUrl: null
      },
      {
        id: 'titax-r603',
        name: 'R-603',
        grade: 'Rutile',
        category: 'Plastic Grade',
        description: 'High-performance plastic grade with excellent opacity, whiteness, and leveling properties. Features low oil absorption and high heat stability.',
        applications: ['Polyolefin', 'PVC', 'ABS', 'Masterbatch', 'High Thermal Stability Plastics'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/ddyu7pyt_TITAX%20TDS%20R-603.pdf',
        mockupUrl: null
      },
      {
        id: 'titax-r702',
        name: 'R-702',
        grade: 'Rutile',
        category: 'Paint & Coating Grade',
        description: 'Superior sulphate process rutile with unparalleled hiding power and excellent gloss. Special surface treatment enhances weather resistance and leveling properties.',
        applications: ['Industrial Coatings', 'Powder Coatings', 'Architectural Coatings'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/3ivh1mub_TITAX%20TDS%20R-702.pdf',
        mockupUrl: null
      },
      {
        id: 'titax-r612',
        name: 'R-612',
        grade: 'Rutile',
        category: 'Ink Grade',
        description: 'Specialized rutile for printing ink industry with high gloss, excellent opacity, and superior dispersibility. Alumina and organic surface treatment.',
        applications: ['Printing Inks', 'Can Coatings', 'High Gloss Interior Coatings'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/pofj129a_TITAX%20TDS%20R-612%20Ink.pdf',
        mockupUrl: null
      },
      {
        id: 'titax-cr522',
        name: 'CR-522',
        grade: 'Chloride Rutile',
        category: 'Plastic Grade',
        description: 'Advanced chloride process plastic grade with excellent dispersibility and dry powder fluidity. Ideal for high-grade masterbatches and various polymers.',
        applications: ['Masterbatch', 'PVC', 'PE', 'ABS', 'PP', 'PS'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/wbzpbmmm_TITAX%20TDS%20CR-522.pdf',
        mockupUrl: null
      },
      {
        id: 'titax-cr531',
        name: 'CR-531',
        grade: 'Chloride Rutile',
        category: 'Paint & Coating Grade',
        description: 'Premium chloride process pigment with high whiteness, dispersibility, and hiding power. Surface treated with aluminum, zirconium, and organics.',
        applications: ['Industrial Coatings', 'Interior Coatings', 'Exterior Coatings', 'Paint', 'Ink'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/3b60vmbi_TITAX%20TDS%20CR-531.pdf',
        mockupUrl: null
      },
      {
        id: 'titax-r504',
        name: 'R-504',
        grade: 'Rutile',
        category: 'Plastic Grade',
        description: 'High-quality plastic grade with uniform particle size and special surface treatment. Features low oil absorption, excellent leveling, and high heat stability.',
        applications: ['Polyolefin', 'PVC', 'Masterbatch', 'Compounds', 'High Thermal Stability Plastics'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/78t1o0p3_TITAX%20TDS%20R-504.pdf',
        mockupUrl: null
      }
    ]
  },
  {
    id: 'albalux',
    name: 'Albalux',
    fullName: 'Albalux Specialty Pigments',
    slug: 'albalux',
    tagline: 'Custom Formulations & Specialty Solutions',
    description: 'Albalux specializes in custom-formulated specialty pigments tailored to your exact requirements. Our technical team works closely with customers to develop bespoke solutions for demanding applications across coatings, plastics, and specialty markets. We also offer a range of standard specialty pigment products for global distribution.',
    customFormulation: {
      enabled: true,
      headline: 'Custom Formulated for Your Needs',
      description: 'Our technical experts can develop specialized pigment formulations precisely matched to your application requirements, performance specifications, and processing conditions.'
    },
    region: 'Global Distribution',
    manufacturer: 'Albalux',
    gradient: 'from-purple-600 to-indigo-700',
    logoUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/bbkyxqu7_albaluxlogo%2Bwhitebg-lowres-01.png',
    products: [
      {
        id: 'albalux-ap243',
        name: 'AP-243',
        grade: 'Specialty Pigment',
        category: 'Coating Grade',
        description: 'Specialized pigment for coatings with enhanced performance characteristics. Designed for demanding coating applications requiring superior properties.',
        applications: ['Industrial Coatings', 'Architectural Coatings', 'Specialty Applications'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/ek7jri0c_Albalux%20TDS%20AP-243.pdf',
        mockupUrl: null
      },
      {
        id: 'albalux-ap540',
        name: 'AP-540',
        grade: 'Specialty Pigment',
        category: 'High Hiding Power',
        description: 'Unparalleled hiding power achieved through unique hydrolysis and calcination process. Features special surface treatment for enhanced weather resistance, low oil absorption, and excellent leveling properties.',
        applications: ['Industrial Coatings', 'Powder Coatings', 'Architectural Coatings', 'Universal Coatings'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/0uz6s3ne_Albalux%20TDS%20AP-540.pdf',
        mockupUrl: null
      },
      {
        id: 'albalux-ap630',
        name: 'AP-630',
        grade: 'Specialty Pigment',
        category: 'Paint Film Enhancer',
        description: 'Enhances paint film performance with superior flexibility, weather resistance, and gloss. Strong dispersion properties with excellent compatibility for water-based resins.',
        applications: ['Industrial Coatings', 'Powder Coatings', 'Interior Architectural', 'Exterior Architectural'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/exs2x4wj_Albalux%20TDS%20AP-630.pdf',
        mockupUrl: null
      },
      {
        id: 'albalux-ap216',
        name: 'AP-216',
        grade: 'Specialty Pigment',
        category: 'Plastics & Masterbatch',
        description: 'Specialized for plastics and masterbatch with special surface treatment. Enhances gloss, brightness, and leveling with low oil absorption and high heat stability.',
        applications: ['Polyolefin', 'PVC', 'Masterbatch', 'Compounds', 'High Thermal Stability Plastics'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/n3eyet3e_Albalux%20TDS%20AP-216.pdf',
        mockupUrl: null
      },
      {
        id: 'albalux-ap252',
        name: 'AP-252',
        grade: 'Specialty Pigment',
        category: 'Premium Performance',
        description: 'Premium specialty pigment engineered for demanding applications. Delivers exceptional performance characteristics across diverse coating systems.',
        applications: ['Industrial Applications', 'Specialty Coatings', 'High-Performance Systems'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/za16pya2_Albalux%20TDS%20AP-252.pdf',
        mockupUrl: null
      },
      {
        id: 'albalux-ap351',
        name: 'AP-351',
        grade: 'Specialty Pigment',
        category: 'Ink Industry Grade',
        description: 'High-performance ink grade with exceptional gloss, opacity, and dispersibility. Features high whiteness and achromatic power for premium printing applications.',
        applications: ['Printing Inks', 'Can Coatings', 'High Gloss Architectural Coatings'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/qys54kk2_Albalux%20TDS%20AP-351.pdf',
        mockupUrl: null
      },
      {
        id: 'albalux-ap2070',
        name: 'AP-2070',
        grade: 'Specialty Pigment',
        category: 'Plastic Grade',
        description: 'Chloride process plastic grade with organic and inorganic surface treatment. Enhances gloss and uniformity, especially effective for recycled products. High thermal stability.',
        applications: ['Polyolefin', 'PVC', 'Masterbatch', 'Compounds', 'High Thermal Stability Plastics'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/865zael9_Albalux%20TDS%20AP-2070.pdf',
        mockupUrl: null
      },
      {
        id: 'albalux-ap5202',
        name: 'AP-5202',
        grade: 'Specialty Pigment',
        category: 'Paint & Coating Grade',
        description: 'Chloride process coating grade with superior opacity and dispersion. Cost-effective solution with excellent leveling properties for diverse coating applications.',
        applications: ['Industrial Coatings', 'Powder Coatings', 'Interior Architectural', 'Exterior Architectural'],
        tdsUrl: 'https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/4a0iuxql_Albalux%20TDS%20AP-5202.pdf',
        mockupUrl: null
      }
    ]
  }
];

export const whyTrustar = [
  {
    id: 1,
    title: 'Global Distribution Network',
    description: 'Strategic presence across Middle East, Africa, and Latin America with optimized supply chain and logistics.',
    icon: 'Network'
  },
  {
    id: 2,
    title: 'Trusted Partnerships',
    description: 'Exclusive and authorized partnerships with world-class manufacturers: Tinergy, Titax, and Albalux.',
    icon: 'Handshake'
  },
  {
    id: 3,
    title: 'Technical Expertise',
    description: 'Deep industry knowledge and application support to help you select optimal products for your needs.',
    icon: 'Lightbulb'
  },
  {
    id: 4,
    title: 'Reliable Supply',
    description: 'Consistent inventory management and strong manufacturer relationships ensuring uninterrupted supply.',
    icon: 'Truck'
  },
  {
    id: 5,
    title: 'Quality Assurance',
    description: 'All products backed by comprehensive technical documentation and certificates of analysis.',
    icon: 'ShieldCheck'
  },
  {
    id: 6,
    title: 'Trust & Integrity',
    description: 'Building lasting relationships through transparency, reliability, and unwavering commitment to customer success.',
    icon: 'Heart'
  }
];
